import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const ClinicalQuickActions = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('actions'); // actions | census
  const [stats, setStats] = useState({
    opdToday: 15, ipdToday: 4, occupiedBeds: 28, dischargesToday: 6
  });
  const loading = false;

  const primaryActions = [
    { name: 'New Registration', path: '/clinical/register', icon: 'bi-person-plus', shortcut: 'Ctrl+P', color: 'reg' },
    { name: 'OPD List', path: '/clinical/opd-list', icon: 'bi-card-list', shortcut: 'Ctrl+O', color: 'opd' },
    { name: 'IPD List', path: '/clinical/ipd-list', icon: 'bi-hospital', shortcut: 'Ctrl+I', color: 'ipd' },
  ];

  const secondaryActions = [
    { name: 'Room Booking', path: '/clinical/room-booking', icon: 'bi-door-open', shortcut: 'Ctrl+B', color: 'room' },
    { name: 'Advance Pay', path: '/clinical/advance', icon: 'bi-cash-stack', shortcut: 'Ctrl+A', color: 'advance' },
    { name: 'Service Details', path: '/clinical/service-details', icon: 'bi-file-medical', shortcut: 'Ctrl+S', color: 'service' },
    { name: 'Discharge Bill', path: '/clinical/discharge-bill', icon: 'bi-receipt', shortcut: 'Ctrl+D', color: 'bill' },
    { name: 'Discharge List', path: '/clinical/discharge-list', icon: 'bi-list-check', color: 'dlist' },
  ];

  return (
    <div className="qa-container">
      {/* Header with Tabs */}
      <div className="qa-header">
        <div className="qa-tabs">
          <button
            className={`qa-tab ${activeTab === 'actions' ? 'active' : ''}`}
            onClick={() => setActiveTab('actions')}
          >
            <i className="bi bi-lightning-charge-fill"></i> Actions
          </button>
          <button
            className={`qa-tab ${activeTab === 'census' ? 'active' : ''}`}
            onClick={() => setActiveTab('census')}
          >
            <i className="bi bi-clipboard-data-fill"></i> Census
          </button>
        </div>
      </div>

      <div className="qa-body">
        {activeTab === 'actions' && (
          <>
            <div className="qa-section-label">
              <span>Front Desk</span>
              <i className="bi bi-star-fill" style={{ color: '#f59e0b', fontSize: '10px' }}></i>
            </div>
            <div className="qa-group">
              {primaryActions.map((action, i) => (
                <button
                  key={i}
                  className={`erp-action-card ${action.color}-card primary-card`}
                  onClick={() => navigate(action.path)}
                >
                  <div className="icon-wrapper"><i className={`bi ${action.icon}`}></i></div>
                  <span className="card-text">{action.name}</span>
                  {action.shortcut && <span className="qa-key">{action.shortcut}</span>}
                </button>
              ))}
            </div>

            <div className="qa-section-label mt-3">
              <span>Wards & Billing</span>
            </div>
            <div className="qa-group compact">
              {secondaryActions.map((action, i) => (
                <button
                  key={i}
                  className={`erp-action-card ${action.color}-card`}
                  onClick={() => navigate(action.path)}
                >
                  <div className="icon-wrapper"><i className={`bi ${action.icon}`}></i></div>
                  <span className="card-text">{action.name}</span>
                  {action.shortcut && <span className="qa-key">{action.shortcut}</span>}
                </button>
              ))}
            </div>
          </>
        )}

        {activeTab === 'census' && (
          <>
            <div className="qa-section-label">
              <span>Today's Census</span>
              <i className="bi bi-calendar-check" style={{ color: '#0d9488', fontSize: '11px' }}></i>
            </div>
            <div className="erp-stats-grid">
              <div className="stat-box box-primary">
                <i className="bi bi-people stat-bg-icon"></i>
                <div className="stat-label">OPD Visits</div>
                <div className="stat-value">{loading ? '...' : stats.opdToday}</div>
              </div>
              <div className="stat-box box-purple">
                <i className="bi bi-bed stat-bg-icon"></i>
                <div className="stat-label">New IPD</div>
                <div className="stat-value">{loading ? '...' : stats.ipdToday}</div>
              </div>
              <div className="stat-box box-teal">
                <i className="bi bi-hospital stat-bg-icon"></i>
                <div className="stat-label">Occupied Beds</div>
                <div className="stat-value">{loading ? '...' : stats.occupiedBeds}</div>
              </div>
              <div className="stat-box box-amber">
                <i className="bi bi-box-arrow-right stat-bg-icon"></i>
                <div className="stat-label">Discharges</div>
                <div className="stat-value">{loading ? '...' : stats.dischargesToday}</div>
              </div>
            </div>

            <div className="qa-section-label mt-3">
              <span>Bed Occupancy</span>
            </div>
            <div className="perf-card">
              <div className="perf-row">
                <span className="perf-label">Beds Occupied</span>
                <span className="perf-value text-accent">28 / 40</span>
              </div>
              <div className="perf-bar">
                <div className="perf-fill" style={{ width: '70%', background: '#0d9488' }}></div>
              </div>
              <div className="perf-row mt-2">
                <span className="perf-label">OPD Queue Cleared</span>
                <span className="perf-value text-success">82%</span>
              </div>
              <div className="perf-bar">
                <div className="perf-fill" style={{ width: '82%', background: '#16a34a' }}></div>
              </div>
            </div>
          </>
        )}
      </div>

      <style>{`
        .qa-container {
          --qa-accent: #0d9488;
          --qa-accent-dark: #0f766e;
          --qa-accent-soft: #f0fdfa;
          --qa-accent-border: #99f6e4;

          display: flex; flex-direction: column;
          height: 100%; background: #ffffff;
        }

        .qa-header {
          border-bottom: 1px solid #f1f5f9;
          background: linear-gradient(180deg, #ffffff 0%, #fafbfc 100%);
        }

        .qa-tabs {
          display: flex; padding: 8px 8px 0 8px;
          gap: 2px;
        }

        .qa-tab {
          flex: 1; background: transparent;
          border: none; padding: 9px 6px;
          font-size: 11px; font-weight: 700;
          color: #64748b; cursor: pointer;
          border-radius: 7px 7px 0 0;
          display: flex; align-items: center;
          justify-content: center; gap: 5px;
          position: relative; transition: all 0.2s;
        }
        .qa-tab i { font-size: 11px; }
        .qa-tab:hover { background: #f8fafc; color: #0f172a; }
        .qa-tab.active {
          background: var(--qa-accent-soft);
          color: var(--qa-accent-dark);
          border-bottom: 2px solid var(--qa-accent);
        }

        .qa-body {
          padding: 12px; overflow-y: auto; flex: 1;
        }
        .qa-body::-webkit-scrollbar { width: 5px; }
        .qa-body::-webkit-scrollbar-thumb {
          background: #cbd5e1; border-radius: 10px;
        }

        .qa-section-label {
          font-size: 10px; font-weight: 800;
          color: #94a3b8; text-transform: uppercase;
          letter-spacing: 0.6px; margin-bottom: 8px;
          display: flex; justify-content: space-between;
          align-items: center;
        }

        .qa-group {
          display: flex; flex-direction: column; gap: 6px;
        }
        .qa-group.compact { gap: 4px; }
        .qa-group.compact .erp-action-card { padding: 6px 10px; }
        .qa-group.compact .icon-wrapper { width: 28px; height: 28px; font-size: 12px; }

        .erp-action-card {
          display: flex; align-items: center;
          width: 100%; padding: 8px 12px;
          border: 1px solid #f1f5f9; border-radius: 9px;
          background: #ffffff;
          box-shadow: 0 1px 2px rgba(15, 23, 42, 0.03);
          cursor: pointer; transition: all 0.2s ease;
          text-align: left;
        }
        .primary-card { padding: 10px 12px; }
        .primary-card .icon-wrapper { width: 36px; height: 36px; font-size: 16px; }

        .erp-action-card:hover {
          transform: translateX(-2px);
          box-shadow: 0 4px 12px rgba(15, 23, 42, 0.08);
          border-color: #e2e8f0;
        }

        .icon-wrapper {
          width: 30px; height: 30px;
          display: flex; align-items: center;
          justify-content: center; border-radius: 8px;
          margin-right: 10px; font-size: 13px;
          transition: all 0.2s;
        }

        .card-text {
          font-size: 12.5px; font-weight: 600;
          color: #475569; flex: 1;
        }

        .qa-key {
          font-size: 10px; background: #f1f5f9;
          padding: 3px 6px; border-radius: 5px;
          color: #64748b; font-family: 'Consolas', monospace;
          font-weight: 600; border: 1px solid #e2e8f0;
          white-space: nowrap;
        }

        /* Clinical action card colors */
        .reg-card .icon-wrapper { background: #dbeafe; color: #2563eb; }
        .reg-card:hover { background: #eff6ff; border-color: #bfdbfe; }
        .reg-card:hover .card-text { color: #1e40af; }

        .opd-card .icon-wrapper { background: #dcfce7; color: #16a34a; }
        .opd-card:hover { background: #f0fdf4; border-color: #bbf7d0; }
        .opd-card:hover .card-text { color: #166534; }

        .ipd-card .icon-wrapper { background: #f3e8ff; color: #9333ea; }
        .ipd-card:hover { background: #faf5ff; border-color: #e9d5ff; }
        .ipd-card:hover .card-text { color: #6b21a8; }

        .room-card .icon-wrapper { background: #ffedd5; color: #ea580c; }
        .room-card:hover { background: #fff7ed; border-color: #fed7aa; }
        .room-card:hover .card-text { color: #9a3412; }

        .advance-card .icon-wrapper { background: #ccfbf1; color: #0d9488; }
        .advance-card:hover { background: #f0fdfa; border-color: #99f6e4; }
        .advance-card:hover .card-text { color: #115e59; }

        .service-card .icon-wrapper { background: #fce7f3; color: #db2777; }
        .service-card:hover { background: #fdf2f8; border-color: #fbcfe8; }
        .service-card:hover .card-text { color: #9d174d; }

        .bill-card .icon-wrapper { background: #fee2e2; color: #dc2626; }
        .bill-card:hover { background: #fef2f2; border-color: #fecaca; }
        .bill-card:hover .card-text { color: #991b1b; }

        .dlist-card .icon-wrapper { background: #e0e7ff; color: #4f46e5; }
        .dlist-card:hover { background: #eef2ff; border-color: #c7d2fe; }
        .dlist-card:hover .card-text { color: #3730a3; }

        /* Stats */
        .erp-stats-grid {
          display: grid; grid-template-columns: 1fr 1fr; gap: 8px;
        }
        .stat-box {
          background: #ffffff; border-radius: 9px;
          padding: 11px; position: relative;
          overflow: hidden;
          box-shadow: 0 1px 2px rgba(15, 23, 42, 0.03);
          border: 1px solid #e2e8f0;
        }
        .stat-bg-icon {
          position: absolute; right: -5px; bottom: -10px;
          font-size: 40px; opacity: 0.05;
        }
        .stat-label {
          font-size: 10px; color: #64748b;
          font-weight: 700; margin-bottom: 3px;
          text-transform: uppercase; letter-spacing: 0.3px;
        }
        .stat-value { font-size: 14px; font-weight: 800; }

        .box-primary { border-left: 4px solid #3b82f6; }
        .box-primary .stat-value { color: #2563eb; }
        .box-purple { border-left: 4px solid #a855f7; }
        .box-purple .stat-value { color: #9333ea; }
        .box-teal { border-left: 4px solid #14b8a6; }
        .box-teal .stat-value { color: #0d9488; }
        .box-amber { border-left: 4px solid #f59e0b; }
        .box-amber .stat-value { color: #d97706; }

        .perf-card {
          background: #f8fafc; border: 1px solid #f1f5f9;
          border-radius: 9px; padding: 12px;
        }
        .perf-row {
          display: flex; justify-content: space-between;
          font-size: 11px; font-weight: 600;
          margin-bottom: 4px;
        }
        .perf-label { color: #64748b; }
        .perf-value { font-weight: 700; }
        .text-success { color: #16a34a; }
        .text-accent { color: #0d9488; }
        .perf-bar {
          height: 6px; background: #e2e8f0;
          border-radius: 10px; overflow: hidden;
        }
        .perf-fill {
          height: 100%; border-radius: 10px;
          transition: width 1s ease;
        }
      `}</style>
    </div>
  );
};

export default ClinicalQuickActions;